<template>
  <div class="container">
    <div class="content-bg">
      <div class="inline-wrapper ranking-date">
        <div class="date-left-r">
          <div style="display: flex;align-items: center;">
            <el-form
              inline
              size="mini"
              class="table-search-part more-search-part inline-wrapper"
              @submit.native.prevent="handleQuery()"
            >
              <el-form-item label="Warning Time" label-width="80px">
                <el-date-picker
                  clearable
                  v-model="chooseDate"
                  type="datetimerange"
                  format="yyyy-MM-dd HH:mm"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="timestamp"
                  range-separator="-"
                  start-placeholder="Start time"
                  end-placeholder="End time"
                />
              </el-form-item>
              <!-- <el-form-item label="Channel Type" style="margin-right: 10px;">
                  <el-select v-model="ChannelType" filterable @change="agentChange">
                    <el-option
                      v-for="item in agentList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>-->
              <el-form-item label="Merchant Level 1" style="margin-left: 10px;">
                <el-select
                  v-model="partner"
                  filterable
                  placeholder="select"
                  @change="partnerChange"
                  clearable
                >
                  <el-option
                    v-for="item in partnerSelect"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Merchant Level 2" style="margin-left: 10px;">
                <el-select
                  v-model="masterDistributor"
                  filterable
                  placeholder="select"
                  @change="masterDistributorChange"
                  clearable
                >
                  <el-option
                    v-for="item in masterDistributorSelect"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="Merchant Level 3" style="margin-right: 10px;">
                  <el-select
                    @change="distributorChange"
                    v-model="distributor"
                    filterable
                    placeholder="select"
                    clearable
                  >
                    <el-option
                      v-for="item  in distributorSelect"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Merchant Level 4" style="margin-right: 10px;">
                  <el-select
                    v-model="company"
                    @change="companyChange"
                    filterable
                    placeholder="select"
                    clearable
                  >
                    <el-option
                      v-for="item in companySelect"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>-->
              <el-form-item label="Channel" style="margin-left: 10px;">
                <el-select
                  v-model="queryData.channelId"
                  placeholder="Merchant"
                  clearable
                  filterable
                  :popper-append-to-body="false"
                  @change="merchantIdChange"
                >
                  <el-option
                    v-for="item in merchatList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="Label" style="margin-left: 10px;">
                <el-select
                  v-model="queryData.labelIds"
                  multiple
                  filterable
                  collapse-tags
                  placeholder="Label"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in lableList"
                    :key="item.id"
                    :label="item.labelName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>-->
            </el-form>
          </div>
          <div>
            <el-form
              inline
              size="mini"
              class="table-search-part more-search-part inline-wrapper"
              @submit.native.prevent="handleQuery()"
            >
              <div>
                <el-form-item label="Warning Type" style="margin-right: 10px;">
                  <el-select v-model="queryData.warningType" filterable clearable>
                    <el-option
                      v-for="item in warningTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Warning Template" style="margin-right: 10px;">
                  <el-select
                    v-model="queryData.templateId"
                    filterable
                    clearable
                    placeholder="User Limit"
                  >
                    <el-option
                      v-for="item in warningTemplateIdList"
                      :key="item.id"
                      :label="item.templateName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="User ID" style="margin-right: 10px;">
                  <el-input v-model="queryData.userId" clearable placeholder="input"></el-input>
                </el-form-item>
                <el-form-item style="margin-right: 10px;">
                  <el-button class="search-btn" :loading="loading" @click="handleQuery()">Search</el-button>
                  <el-button
                    class="lebel-risk-export-btn"
                    @click="handleExport()"
                    :loading="exportLoading"
                  >Download</el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <div class="middle-btn inline-wrapper">
        <div class="middle-left"></div>
        <div class="inline-right middle-left"></div>
      </div>
      <div class="ranking-table">
        <el-table
          ref="table"
          :data="list"
          :height="tableHeight"
          v-loading="loading"
          header-row-class-name="table-header-row"
          border
          stripe
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Time" min-width="148">
            <template v-slot="{row}">
              <div>{{ formatUtcMs(row.warningTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Warning Day" min-width="148">
            <template v-slot="{row}">{{ formatUtc(row.reportDate) }}</template>
          </el-table-column>
          <el-table-column label="Warning Type" min-width="148">
            <template v-slot="{row}">{{ feachWarningType(row.warningType) }}</template>
          </el-table-column>
          <el-table-column label="Channel" min-width="130">
            <template v-slot="{row}">
              <div>{{row.merchantName}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Warning Template"
            prop="templateName"
            min-width="140"
            align="center"
          ></el-table-column>
          <el-table-column label="User ID" prop="userId" min-width="120" align="center">
            <template v-slot="{row}">
              <span v-if="row.warningType == 1 || row.warningType == 2">--</span>
              <span v-else>{{ row.userId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Stake" prop="stake" min-width="140" align="center">
            <template v-slot="{row}">{{ formatAmount(row.stake)}}</template>
          </el-table-column>
          <el-table-column label="Stake%" min-width="148" align="center">
            <template v-slot="{row}">{{ (row.stakeWarning * 100).toFixed(2)}}%</template>
          </el-table-column>
          <el-table-column label="PL" prop="profit" min-width="90" align="center">
            <template v-slot="{row}">{{ formatAmount(row.profit) }}</template>
          </el-table-column>
          <el-table-column label="PL%" prop="profitWarning" min-width="90" align="center">
            <template v-slot="{row}">{{ (row.profitWarning * 100).toFixed(2) }}%</template>
          </el-table-column>
          <el-table-column
            label="Remark"
            :show-overflow-tooltip="true"
            prop="remark"
            min-width="200"
            align="left"
          >
            <template v-slot="{row}">
              <div>{{ row.remark }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Operator" prop="operator" min-width="80" align="center"></el-table-column>
          <el-table-column label="Operation" align="center" min-width="140">
            <template v-slot="{ row }">
              <div class="dialog-footer1 table-search-part">
                <el-button class="search-btn" @click="handleRemark(row)">Remark</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrapper inline-wrapper">
        <el-pagination
          class="inline-right"
          :total="total"
          :current-page="queryData.current"
          :page-size="queryData.size"
          :page-sizes="[50, 100, 200]"
          @current-change="changePage"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <!-- 修改Remark-->
      <div class="select-down-wrapper">
        <el-form label-width="80px">
          <el-form-item label="Remark">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="Remark"
              v-model="queryRemarkData.remark"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleAdd()">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import echarts from "echarts";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import { getMerchat } from "@/api/member";
import {
  getWarningTemplateList,
  channelWarningHistory,
  channelWarningRemark,
  downloadChannelWarnings
} from "@/api/channel";

export default {
  name: "RankingList",
  data() {
    return {
      userLevelUpdateTime: [],
      partnerSelect: [], // 合伙商列表
      masterDistributorSelect: [], // 总经销列表
      distributorSelect: [], // 经销商
      companySelect: [], // 公司
      ChannelType: 1,
      exportLoading: false,
      partner: "",
      masterDistributor: "",
      distributor: "",
      company: "",
      agentList: [
        { id: 1, val: false, name: "All" },
        { id: 2, val: true, name: "Directly Channel" }
      ],
      warningTypeList: [
        { id: 1, name: "Channel Stake" },
        { id: 2, name: "Channel PL" },
        { id: 3, name: "User Stake" },
        { id: 4, name: "User PL" }
      ],
      list: [],
      merchatList: [],
      chooseDate: [],
      warningTemplateIdList: [],
      loading: false,
      queryData: {
        warningStartTime: "",
        warningEndTime: "",
        templateId: "",
        warningType: "",
        current: 1,
        size: 50,
        userId: "",
        merchantId: "",
        channelId: ""
      },
      queryRemarkData: {
        id: "",
        remark: ""
      },
      num: 1,
      total: 0,
      tableHeight: window.innerHeight,
      title: "Batch Modifying Label"
    };
  },
  methods: {
    formatAmountHtml(value) {
      let amount = Number(value).toFixed(2);
      amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return amount;
    },
    // merchant下拉框
    async fetchMerchantList() {
      let paramData = {};
      const res = await getMerchat(paramData);
      let data = res.data || {};

      this.merchantParserData = this.parserMerchantSelectedHttpResponse(res);
      this.merchatList = this.objToArray(this.merchantParserData.channels);
      this.partnerSelect = this.objToArray(this.merchantParserData.level1);
      this.masterDistributorSelect = this.objToArray(
        this.merchantParserData.level2
      );
      this.distributorSelect = this.objToArray(this.merchantParserData.level3);
      this.companySelect = this.objToArray(this.merchantParserData.level4);
    },
    //最新改为前端处理
    objToArray(obj) {
      if (Array.isArray(obj)) {
        return obj;
      }
      let arr = [];
      for (let key in obj) {
        let objIten = {
          id: key,
          name: obj[key].name
        };
        arr.push(objIten);
      }
      return arr;
    },
    queryLevelFromArray(localMerchantData, agents, level) {
      for (const agent of agents) {
        // 如果本地没有 agent 数据, 初始化本地数据
        if (!localMerchantData[`level${agent.level}`][agent.id]) {
          localMerchantData[`level${agent.level}`][agent.id] = {
            name: agent.name,
            childs: {},
            channels: {},
            directlyChannels: {}
          };
        }
        if (agent.level == level) {
          return {
            id: agent.id,
            name: agent.name
          };
        }
      }
      return null;
    },

    setChildAgent(localMerchantData, level, parent, child) {
      let parentLevel = localMerchantData[`level${level}`];
      let childLevel = localMerchantData[`level${level + 1}`];
      if (!parent || !child) {
        return;
      }
      parentLevel[parent.id].childs[child.id] = child.name;
      childLevel[child.id].parentId = parent.id;
    },

    setAgentChannel(agentLevel, agent, channel) {
      if (!agent || !agentLevel[[agent.id]]) {
        return;
      }
      agentLevel[agent.id].channels[channel.id] = channel.name;
    },

    parserMerchantSelectedHttpResponse(response) {
      let localMerchantData = {
        level1: {},
        level2: {},
        level3: {},
        level4: {},
        channels: {}
      };
      for (const merchantData of response.data) {
        let channel = {
          name: merchantData.name,
          agents: [
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 1),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 2),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 3),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 4)
          ]
        };

        localMerchantData.channels[merchantData.id] = channel;

        let simpleChannel = { id: merchantData.id, name: channel.name };

        // 配置商户底下的渠道
        this.setAgentChannel(
          localMerchantData.level1,
          channel.agents[0],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level2,
          channel.agents[1],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level3,
          channel.agents[2],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level4,
          channel.agents[3],
          simpleChannel
        );

        // 配置商户阶层关系的渠道
        this.setChildAgent(
          localMerchantData,
          1,
          channel.agents[0],
          channel.agents[1]
        );
        this.setChildAgent(
          localMerchantData,
          2,
          channel.agents[1],
          channel.agents[2]
        );
        this.setChildAgent(
          localMerchantData,
          3,
          channel.agents[2],
          channel.agents[3]
        );

        for (let i = channel.agents.length; i > 0; i--) {
          if (channel.agents[i - 1] != null) {
            let agent = channel.agents[i - 1];
            localMerchantData[`level${i}`][agent.id].directlyChannels[
              merchantData.id
            ] = merchantData.name;
            break;
          }
        }
      }

      return localMerchantData;
    },

    getDirectChinnel(agentLevel, directlyChannel = false) {
      let channels = [];
      let x = directlyChannel
        ? agentLevel.directlyChannels
        : agentLevel.channels;
      for (const [channelId, channelName] of Object.entries(x)) {
        channels.push({
          id: channelId.toString(),
          name: channelName
        });
      }
      return channels;
    },

    getDirectAgent(localMerchantData, level, agentId) {
      let childAgents = [];
      let childs =
        level > 0
          ? localMerchantData[`level${level}`][agentId].childs
          : localMerchantData[`level1`];
      for (const [childAgentId, childAgentName] of Object.entries(childs)) {
        childAgents.push({
          id: childAgentId.toString(),
          name: childAgentName.name || childAgentName
        });
      }
      return childAgents;
    },

    chooseLevelMerchant(
      localMerchantData,
      level,
      agentId,
      directlyChannel = false
    ) {
      let result = {
        chooseLevel1: null,
        chooseLevel2: null,
        chooseLevel3: null,
        chooseLevel4: null,
        chooseChannel: null,
        level1: [],
        level2: [],
        level3: [],
        level4: [],
        channels: []
      };

      let chooseAgent = null;
      let currentLevel = null;

      if (level >= 5) {
        // 给定指定渠道
        let channel = localMerchantData[`channels`][agentId];
        let chooseChannel = {
          id: agentId.toString(),
          name: channel.name
        };
        result[`chooseChannel`] = chooseChannel;
        channel.agents.forEach((agent, index) => {
          if (!agent) {
            return;
          }
          level = index + 1;
          agentId = agent.id;
        });
      }

      if (level > 0 && level < 5) {
        chooseAgent = {
          id: agentId.toString(),
          name: localMerchantData[`level${level}`][agentId].name
        };

        // 给定当前等级
        result[`chooseLevel${level}`] = chooseAgent;

        currentLevel = level;
        let currentAgentId = agentId;
        // 给定父级
        while (currentLevel > 1) {
          let parentId =
            localMerchantData[`level${currentLevel}`][currentAgentId].parentId;
          let parent = {
            id: parentId.toString(),
            name: localMerchantData[`level${currentLevel - 1}`][parentId].name
          };
          result[`chooseLevel${currentLevel - 1}`] = parent;
          let currentLevelAgents = this.getDirectAgent(
            localMerchantData,
            currentLevel - 1,
            parentId
          );
          result[`level${currentLevel}`] = currentLevelAgents;

          currentLevel -= 1;
          currentAgentId = parentId;
        }
      }

      let level1Agents = this.getDirectAgent(localMerchantData, 0);
      result[`level1`] = level1Agents;

      // 给定子级跟渠道
      if (level > 0 && level < 5) {
        result.channels = result.channels.concat(
          this.getDirectChinnel(
            localMerchantData[`level${level}`][agentId],
            directlyChannel
          )
        );
      }
      currentLevel = null;
      let currentAgents = null;
      if (level == 0) {
        let currentLevelAgents = this.getDirectAgent(localMerchantData, 0);
        result[`level1`] = currentLevelAgents;

        for (const [agentId, agentLevel] of Object.entries(
          localMerchantData[`level${level + 1}`]
        )) {
          result.channels = result.channels.concat(
            this.getDirectChinnel(
              localMerchantData[`level${level + 1}`][agentId]
            )
          );
        }
        currentLevel = 1;
        currentAgents = result[`level1`];
      } else {
        currentAgents = [result[`chooseLevel${level}`]];
        currentLevel = level;
      }

      while (currentLevel < 4) {
        for (const agent of currentAgents) {
          for (const [childId, childName] of Object.entries(
            localMerchantData[`level${currentLevel}`][agent.id].childs
          )) {
            result[`level${currentLevel + 1}`].push({
              id: childId.toString(),
              name: childName
            });
          }
        }
        currentLevel += 1;
        currentAgents = result[`level${currentLevel}`];
      }
      return result;
    },
    agentChange(val) {
      this.queryData.channelId = "";
      this.merchatList = [];
      this.partner = "";
      this.partnerSelect = [];
      this.masterDistributor = "";
      this.masterDistributorSelect = [];
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.merchatList = this.objToArray(this.merchantParserData.channels);
      this.partnerSelect = this.objToArray(this.merchantParserData.level1);
      this.masterDistributorSelect = this.objToArray(
        this.merchantParserData.level2
      );
      this.distributorSelect = this.objToArray(this.merchantParserData.level3);
      this.companySelect = this.objToArray(this.merchantParserData.level4);
    },
    formatOptionData(filterMerchantData) {
      const {
        level1,
        level2,
        level3,
        level4,
        chooseLevel1,
        chooseLevel2,
        chooseLevel3,
        chooseLevel4,
        channels
      } = filterMerchantData;
      this.partnerSelect = level1 || [];
      this.masterDistributorSelect = level2 || [];
      this.distributorSelect = level3 || [];
      this.companySelect = level4 || [];
      this.partner = chooseLevel1?.id || "";
      this.masterDistributor = chooseLevel2?.id || "";
      this.distributor = chooseLevel3?.id || "";
      this.company = chooseLevel4?.id || "";
      this.merchatList = channels;
    },
    merchantIdChange(val) {
      if (!val) {
        return;
      }
      let status = this.ChannelType == 1 ? false : true;
      let filterMerchantData = this.chooseLevelMerchant(
        this.merchantParserData,
        5,
        val,
        status
      );
      this.formatOptionData(filterMerchantData);
    },
    //level 1
    partnerChange(val) {
      this.masterDistributor = "";
      this.masterDistributorSelect = [];
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.queryData.channelId = "";
      if (!val) {
        this.merchatList = this.objToArray(this.merchantParserData.channels);
        this.partnerSelect = this.objToArray(this.merchantParserData.level1);
        this.masterDistributorSelect = this.objToArray(
          this.merchantParserData.level2
        );
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }

      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          1,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 2
    masterDistributorChange(val) {
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.queryData.channelId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          1,
          this.partner,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.masterDistributorSelect = this.objToArray(
          this.merchantParserData.level2
        );
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          2,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 3
    distributorChange(val) {
      this.company = "";
      this.companySelect = [];
      this.queryData.channelId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          2,
          this.masterDistributor,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          3,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 4
    companyChange(val) {
      this.queryData.channelId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          3,
          this.distributor,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          4,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    async getWarningList() {
      const res = await getWarningTemplateList({
        current: 1,
        size: 100
      });
      this.warningTemplateIdList = res.data || [];
    },
    async getList() {
      this.loading = true;
      if (this.chooseDate) {
        this.queryData.warningStartTime = this.chooseDate[0];
        this.queryData.warningEndTime = this.chooseDate[1];
      } else {
        this.queryData.warningStartTime = "";
        this.queryData.warningEndTime = "";
      }
      try {
        let merchantId = "";
        if (this.masterDistributor) {
          merchantId = this.masterDistributor;
        } else if (this.partner) {
          merchantId = this.partner;
        }
        let param = {
          ...this.queryData,
          merchantId: merchantId
        };
        const res = await channelWarningHistory(param);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async handleExport() {
      try {
        this.exportLoading = true;
        const timeZoneOffset = this.$moment().utcOffset() / 60;
        let param = {
          ...this.queryData,
          timeZone: timeZoneOffset
        };

        // 使用 await 等待 downloadChannelWarnings 函数执行完成
        await downloadChannelWarnings(param, "export.xlsx");

        // downloadChannelWarnings 函数执行完成后，设置 loading 为 false
        this.exportLoading = false;
      } catch (error) {
        console.error(error);
        this.exportLoading = false;
      }
    },
    async handleAdd() {
      try {
        const res = await channelWarningRemark(this.queryRemarkData);
        if (res.success) {
          this.getList();
          this.$message({ message: "update success", type: "success" });
        } else {
          this.$message({
            message: "update warning",
            type: "warning"
          });
        }
        this.Close();
      } catch (error) {
        console.error(error);
      }
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
      this.isFirstTime = true;
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList(true);
    },
    handleRemark(data) {
      // 修改
      this.queryRemarkData.id = data.id;
      this.queryRemarkData.remark = data.remark;
      this.title = "Modify Remark";
      this.$refs["dialogDom"].isShowDia(this.title, true, "600px");
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "600px");
    },
    formatUtcMs(time) {
      return time ? this.$moment(+time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    formatUtc(time) {
      return time ? this.$moment(+time).format("YYYY-MM-DD") : "";
    },
    formatAmount(value) {
      let val2f = Number(value).toFixed(2);
      return val2f.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    feachWarningType(val) {
      let name = "";
      if (!val) {
        name = "";
      }
      this.warningTypeList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    }
  },
  components: {
    dia,
    Empty
  },
  computed: {},
  mounted() {
    let d = [];
    d = [
      new Date(new Date().toLocaleDateString()).getTime() -
        7 * 24 * 60 * 60 * 1000,
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    ];
    this.chooseDate = d;
    this.queryData.warningStartTime = d[0];
    this.queryData.warningEndTime = d[1];
    this.fetchMerchantList();
    this.getWarningList();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.ranking-date,
.export-wrapper {
  font-size: 12px;
  margin: 10px 0;
  .header-tab {
    display: flex;
    align-items: center;
    height: 32px;
    width: 200px;
    margin-right: 10px;
    span {
      width: 100px;
      text-align: center;
      cursor: pointer;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      &.active {
        color: #fff;
        background: #00a791;
        border: 1px solid #00a791;
      }
      &:hover {
        opacity: 0.7;
      }
    }
    .fisrt-box {
      border-radius: 4px 0 0 4px;
      border-right: 0;
    }
    .two-box {
      border-radius: 0 4px 4px 0;
      border-left: 0;
    }
  }
}
.middle-btn {
  margin: 0 0 10px 0;
}
.lebel-risk-export-btn:hover {
  border: 1px solid #00a791;
}
.label-btn {
  border: 1px solid #dcdfe6;
  width: 102px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order-amount-wrapper {
  text-align: center;
  background-color: #fff;
  border-radius: 16px;
  .time-range-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .time-range {
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 100px;
      display: flex;
      border: 1px solid #ebedf3;
      p {
        color: #414b5f !important;
        font-weight: normal;
        font-size: 13px;
        padding: 7px 35px;
        margin-left: 0;
        border-right: 1px solid #ebedf3;

        box-sizing: border-box;
        cursor: pointer;
        &:last-child {
          border-right: 0;
          border-radius: 0 100px 100px 0;
        }
        &:first-child {
          border-radius: 100px 0px 0px 100px;
        }
        &.active {
          color: #fff !important;
          background: #00a791;
          border: 1px solid #00a791;
        }
      }
    }
  }
}
#orderAmount {
  height: 378px;
}
.icona-Property1baocun {
  font-size: 12px;
}
.odds-tag {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  margin-right: 6px;
  background: #00a791;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.iconqushi {
  font-size: 16px;
  color: #0184b8;
}
.el-range-editor--small.el-input__inner {
  width: 260px;
}
/deep/.el-input-group__append {
  padding: 0 5px !important;
}
/deep/.el-date-editor--week {
  width: 140px !important;
}
.label-box {
  /deep/.el-input {
    width: 240px !important;
  }
}
.select-down-wrapper {
  /deep/.el-textarea__inner {
    border: 1px solid #dcdfe6 !important;
  }
}
.dialog-footer1 {
  padding-top: 0 !important;
}
</style>
